import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { sendpush } from "../../../services/push";
import { listBranches } from "../../../services/admin";

/**
 * Push Notification > Send Push. Pick an audience (all / members / employees),
 * optionally scope it to one or more branches, type a title and message and
 * send. Delivery goes out through OneSignal server-side; this screen only
 * composes the broadcast.
 */
export default function SendPush() {
    const navigate = useNavigate();
    const [sentTo, setSentTo] = useState("members");
    const [branchIds, setBranchIds] = useState([]);
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [branches, setBranches] = useState([]);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        // Only active branches can be targeted.
        listBranches().then((res) => {
            if (res?.status === true && Array.isArray(res.data)) {
                const active = res.data.filter((b) => Number(b.active) === 1);
                setBranches(
                    active.map((b) => ({
                        value: b.id,
                        label: b.branch_name || b.name,
                    }))
                );
            }
        });
    }, []);

    function handlesubmit(e) {
        e.preventDefault();

        if (!title.trim()) {
            toast.error("Enter a title.");
            return;
        }
        if (!message.trim()) {
            toast.error("Enter a message.");
            return;
        }

        const temp = new FormData();
        temp.append("sent_to", sentTo);
        // Empty = all branches.
        temp.append("branch_ids", branchIds.map((b) => b.value).join(","));
        temp.append("title", title.trim());
        temp.append("message", message.trim());

        setSending(true);
        sendpush(temp)
            .then((res) => {
                if (res?.status === true) {
                    toast.success(res.message);
                    setTitle("");
                    setMessage("");
                    navigate("/push/list/");
                } else if (res?.message) {
                    toast.error(res.message);
                }
            })
            .finally(() => setSending(false));
    }

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Send Push</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Push Notification</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Send Push
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                                <h2 className="main-content-title tx-24 mg-b-5">
                                    Compose Notification
                                </h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Send To <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                className="form-control"
                                                value={sentTo}
                                                onChange={(e) => setSentTo(e.target.value)}
                                            >
                                                <option value="members">Members</option>
                                                <option value="employees">Employees</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="mb-3">
                                            <label className="form-label">Branch (Leave empty to send to all branches.)</label>
                                            <Select
                                                isMulti
                                                options={branches}
                                                value={branchIds}
                                                onChange={(vals) => setBranchIds(vals || [])}
                                                placeholder="All Branches"
                                                closeMenuOnSelect={false}
                                            />
                                            {/* <small className="text-muted">
                                                Leave empty to send to all branches.
                                            </small> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Title <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Title"
                                                value={title}
                                                maxLength={150}
                                                onChange={(e) => setTitle(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Message <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                placeholder="Enter Message"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                            />
                                            <small className="text-muted">
                                                {message.length} characters
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-end">
                                        <a
                                            type="submit"
                                            className={`btn btn-success ${sending ? "disabled" : ""}`}
                                            onClick={sending ? undefined : handlesubmit}
                                        >
                                            {sending ? "Sending..." : "Send Push"}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
